import React from 'react'
import { ChargingSession } from '../../types/chargingSession.types'
import { ComponentInfoProps } from '../../../../common/types/componentInfo.types'
import { useSingleChargingSessionAdmin } from '../../hooks/useChargingSession'
import { limitString } from '../../../../utils/string.utils';
import { dateConverter } from '../../../../utils/dateConverter';
import { numberFormaterString } from '../../../../utils/numberFormater';

const isEmptyTime = (value?: string) => {
    if (!value) return true;
    if (value === "0001-01-01T00:00:00Z" || value === "0001-01-01T00:00:00.000Z") {
        return true;
    }
    return false;
}

export default function SingleChargingSessionInfo({ info, id, emptyText, limitText, renderComponent }:ComponentInfoProps<ChargingSession>) {
  
    
    const { singleChargingSessionQuery: {isError, isLoading, data}} = useSingleChargingSessionAdmin(id);

    if (isLoading) return <>...</>
    if (isError) return <>{emptyText ? emptyText : ""}</>
    const translateInfo = (valueKey: keyof ChargingSession, valueRaw : any) => {
        if (!valueKey) return "";

        switch (valueKey) {

            case "cs_end_time":
            return !isEmptyTime(valueRaw as any) ? dateConverter(valueRaw as any, {withTime: true}) : emptyText ||"N/A";
            case "cs_start_time":
              return !isEmptyTime(valueRaw as any) ? dateConverter(valueRaw as any, {withTime: true}) : emptyText || "N/A";
            case "cs_create_at":
                return dateConverter(valueRaw as any, {withTime: true});
            case "cs_update_at":
                return dateConverter(valueRaw as any, {withTime: true});
            case "cs_price":
                return numberFormaterString(valueRaw as any);
            case "cs_paygo_credit_nb_kwh_remaining":
                return Number(valueRaw).toFixed(2);
            case "cs_nb_kwh":
                return Number(valueRaw).toFixed(2);
            default:
                return valueRaw;
        }
    }

    
    if (renderComponent ){
        return<>{
         renderComponent({
        value: data?.[info],
        labelRender: <span>{info}</span>,
        goTo: () => null,
    })}
    </>
}

  
    const value = translateInfo(info,data?.[info])


    return (
    <> {value ? limitString(value, limitText): emptyText} </>
  )

}
